import type { PiniaPluginContext } from 'pinia';

import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';
import { watch } from 'vue';

export default function resetStore({ pinia, store, options }: PiniaPluginContext): void {
  const initialState = cloneDeep(store.$state);
  store.$reset = () => store.$patch(cloneDeep(initialState));

  const resetOn = options.resetOnBrandChange;
  if (!resetOn) return;

  const keep = typeof resetOn === 'object' ? resetOn.keep : [];
  watch(
    () => pinia.state.value.identity?.currentBrandLabel,
    () => store.$patch(cloneDeep(omit(initialState, keep))),
  );
  // Kept state is per user, not per brand.
  if (keep.length) {
    watch(
      () => pinia.state.value.identity?.identity?.id,
      () => store.$reset(),
    );
  }
}
